module.exports = {
  __depends__: [
    require(145),
    require(104),
    require(166),
    require(114)
  ],
  __init__: [ 'paletteProvider' ],
  paletteProvider: [ 'type', require(35) ]
};
